import { Component, OnInit } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'core-block-card-callouts',
    templateUrl: './block-card-callouts.component.html',
    styleUrl: './block-card-callouts.component.scss',
    standalone: false,
})
export class BlockCardCalloutsComponent extends BlockAbstractComponent implements OnInit {
    protected getCardImage(image: string): string {
        if (environment.isLocalhost) {
            return (this.configService.get('frontend') ?? '') + image;
        }

        return image;
    }
}
